/**
 * Smooth-scroll for in-page CTAs (hb-scroll-cta). Uses delegation so links
 * work regardless of section render order on the homepage.
 */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest && e.target.closest('a.hb-scroll-cta[href^="#"]');
    if (!link) return;

    var hash = link.getAttribute('href');
    if (!hash || hash.length < 2) return;

    var target = document.getElementById(hash.slice(1));
    if (!target) return;

    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
